import Vue from 'vue'
import VueRouter from 'vue-router'
/* eslint-disable */
// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserAcessPermissions, validateAccess, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
// import apps from './routes/apps'
import pages from './routes/pages'
import main from './routes/main'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/' },
    // ...apps,
    ...pages,
    ...main,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  let userData = getUserData()
  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login' })
    return next({ name: 'misc-not-authorized' })
  } else {
    // If logged in => not authorized
    if (to.fullPath == "/") {
      console.log('en full path', userData.data.access[0]);
      const nameRouter = getHomeRouteForLoggedInUser(
        userData?.role || null,
        userData?.data?.access || userData?.access || []
      );

      // Verifica si ya estás en la ruta antes de redirigir
      if (nameRouter !== to.name) {
        return next({ name: nameRouter });
      }
    }
  }
  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    console.log('en el otro we', userData.data.access[0]);
    const nameRouter = getHomeRouteForLoggedInUser(
      userData?.role || null,
      userData?.data?.access || userData?.access || []
    );
    
    // Verifica si ya estás en la ruta antes de redirigir
    if (nameRouter !== to.name) {
      return next({ name: nameRouter });
    }
  }
  else {
    // console.log('to.meta.redirectIfLoggedIn',to)
    // console.log('isLoggedIn',isLoggedIn)
    console.log('no se aqui')
    // console.log('this.$store.state.back.indexTab',this.$store.state.back.indexTab)
    // next(getHomeRouteForLoggedInUser(userData ? userData.user_type.name.toLowerCase() : null))
    // let permissions = getUserAcessPermissions(userData.user_type.name)
    // console.log('permissionsMiddleware', permissions)
    // let hasPermission = validateAccess(to, permissions, userData.user_type.name)
    // console.log(' asdasd ',userData)
    // const nameRouter = getHomeRouteForLoggedInUser(userData ? userData.user_type.name.toLowerCase() : null, userData? userData.access[0].route : null)
    // console.log('no se aqui nameRouter',nameRouter)
    // console.log('nameRouter', nameRouter, to.name, hasPermission)
    // if (!hasPermission && to.name != "auth-login" && to.name != "misc-not-authorized" && to.name != nameRouter && to.name != undefined) {
    //   return next({ name: 'misc-not-authorized' })
    // }

  }
  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
